import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";

const UserInfo = () => {
  const { instance, accounts } = useMsal();
  const [userInfo, setUserInfo] = useState(null);
  const emailid = localStorage.getItem("myemail");
  const userMap =
    accounts && accounts.length > 0 && accounts[0]?.tenantProfiles;
  const firstValue = userMap.values().next().value; // Get the first value in the Map
  const firstName = firstValue?.name || "Name not found";
  localStorage.setItem("userName", firstName);
  useEffect(() => {
    const getUserInfo = async () => {
      if (accounts.length > 0) {
        try {
          const accessTokenResponse = await instance.acquireTokenSilent({
            account: accounts[0],
          });

          if (accessTokenResponse.accessToken) {
            const response = await instance.api("/me").get();
            setUserInfo(response);
          }
        } catch (error) {
          console.error("Error fetching user info:", error);
        }
      }
    };

    getUserInfo();
  }, [instance, accounts]);

  return (
    <div>

      {firstName ? (
        <div>
          <p style={{fontSize:'24px',fontWeight:"600"}}>Welcome, {firstName}</p>
          {/* <p style={{fontSize:'18px'}}>Welcome</p> */}
          {/* Add more user properties as needed */}
        </div>
      ) : (
        <p>Loading user info...</p>
      )}
    </div>
  );
};

export default UserInfo;
